import { Fragment, useEffect, useRef } from "react";

type StepChipsProps = {
  activeStep: number;
  ariaLabel: string;
  className?: string;
  steps: readonly string[];
};

export function StepChips({ activeStep, ariaLabel, className = "", steps }: StepChipsProps) {
  const containerRef = useRef<HTMLElement>(null);
  const activeStepRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    const activeItem = activeStepRef.current;
    if (!container || !activeItem) return;
    container.scrollTo({
      left: activeItem.offsetLeft - (container.clientWidth - activeItem.clientWidth) / 2,
      behavior: "smooth",
    });
  }, [activeStep]);

  return (
    <nav ref={containerRef} className={`step-chips${className ? ` ${className}` : ""}`} aria-label={ariaLabel}>
      {steps.map((label, index) => (
        <Fragment key={label}>
          {index > 0 ? <span className="step-chips-separator" aria-hidden="true">›</span> : null}
          <span ref={index === activeStep ? activeStepRef : undefined} className={index === activeStep ? "active" : ""} aria-current={index === activeStep ? "step" : undefined}>
            {label}
          </span>
        </Fragment>
      ))}
    </nav>
  );
}
